import EditIcon from '@mui/icons-material/Edit';
import {
    Button,
    Chip,
    CircularProgress,
    Divider,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { settingsRoutes } from '../../../../routes';
import { useAiSmartReplyPlans } from '../../../../sic-lib/api/hooks/useAiSmartReply';
import AxiosErrorAlert from '../../../Shared/Alerts/AxiosErrorAlert';
import { CreateSmartReplyPlanDrawer } from './CreatePlan/CreateSmartReplyPlanDrawer';

export default function SmartReplyManagement() {
    const history = useHistory();
    const [isNewOpen, setIsNewOpen] = useState(false);
    const { data: plans, isLoading, isError, error } = useAiSmartReplyPlans();

    const handleNavigateToEditNew = (planId?: number) => {
        history.push(settingsRoutes.setBuildSmartReplyPlan(planId));
    };

    return (
        <>
            <Paper>
                <Grid container flexDirection="row">
                    <Grid item container justifyContent="space-between" alignItems="center" p={2}>
                        <Grid item>
                            <Typography variant="h5">Smart Reply Plans</Typography>
                        </Grid>
                        <Grid item>
                            <Button onClick={() => setIsNewOpen(true)} variant="outlined">
                                New Plan
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
                <Divider />
                {isLoading && (
                    <Grid display="flex" justifyContent="center" m={2}>
                        <CircularProgress />
                    </Grid>
                )}
                <TableContainer>
                    <Table>
                        <TableBody>
                            {!isLoading &&
                                plans &&
                                plans.length > 0 &&
                                plans.map(plan => (
                                    <TableRow
                                        key={plan.planId}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell>
                                            <Typography variant="body1">{plan.name}</Typography>
                                            <Typography variant="caption">
                                                {plan.description}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Grid
                                                container
                                                spacing={1}
                                                alignItems="center"
                                                justifyContent="flex-end"
                                            >
                                                {plan.userName && (
                                                    <Grid item>
                                                        <Chip
                                                            label={plan.userName}
                                                            variant="outlined"
                                                            size="small"
                                                        />
                                                    </Grid>
                                                )}
                                                <Grid item>
                                                    <Chip
                                                        label={
                                                            plan.clientId
                                                                ? `Client: ${plan.clientId}`
                                                                : 'Global'
                                                        }
                                                        variant="outlined"
                                                        size="small"
                                                    />
                                                </Grid>
                                                <Grid item>
                                                    <IconButton
                                                        edge="end"
                                                        aria-label="edit"
                                                        onClick={() =>
                                                            handleNavigateToEditNew(plan.planId)
                                                        }
                                                    >
                                                        <EditIcon />
                                                    </IconButton>
                                                </Grid>
                                            </Grid>
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                {isError && <AxiosErrorAlert error={error} />}
            </Paper>
            <CreateSmartReplyPlanDrawer
                isOpen={isNewOpen}
                handleClose={() => setIsNewOpen(false)}
            />
        </>
    );
}
